import { Integration } from "../../../../../types"
import { useIntegrationSettingsForm } from "../../../../hooks"
import If from "../../../if"
import RateTableSelector from "../rate-table-selector"

interface Props {
  integration?: Integration
}

const RateTableOption = ({ integration }: Props) => {
  const { app_settings, saveSetting } = useIntegrationSettingsForm(integration)

  const { settings } = app_settings ?? {}

  const onChangeRateTable = () => {
    saveSetting({
      rateTable: !settings?.rateTable
    })
  }

  return (
    <div className="py-2">
      <input
        onChange={onChangeRateTable}
        checked={settings?.rateTable ?? false}
        id="rateTable"
        name="rateTable"
        type="checkbox"
        className="h-6 w-6 rounded border-neural-400 text-primary-500 focus:ring-primary-300 cursor-pointer"
      />
      <label htmlFor="rateTable" className="select-none ml-3 cursor-pointer">
        Rate Table
      </label>
      <If
        condition={!!integration && !!settings?.rateTable}
        then={<RateTableSelector integration={integration!} />}
      />
    </div>
  )
}

export default RateTableOption
